<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/118dEzQ/tc-custom/9781609252557.jpg?1728259273589" alt="This image is the cover for the book Millionth Circle"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Millionth Circle
      </h1>
      <p class="bookDescription body article font2">
        <b>A guide to using female connection and empowerment as a force for change. “Short and poetic . . . a fine resource for building community.” —<i>Spirituality &amp; Practice</i></b><br/><br/>The minds and spirits of women are powerful forces, particularly when harnessed in communion with other women. Women’s circles have been around for quite some time, and their presence is a healing and strengthening source for many. Furthermore, author and psychiatrist Jean Shinoda Bolen believes that women’s circles act as catalysts for change around the world. In this inspiring and spiritual book for women, Dr. Bolen provides both a guide and vision for women seeking purpose and change.<br/><br/>Through her poetic language, Dr. Bolen emphasizes to her readers the importance of using their intuition and drawing upon their own insights. In bringing feminine values such as relationship, nurturing, and equality together, Dr. Bolen shares how women create a space for compassionate and radical growth.<br/><br/>By focusing on both the psychological and spiritual, women open the doorway for great change and empower one another to be leaders of positive change in their own lives and beyond. In this way, women empowerment itself acts as a tool for societal and psychospiritual change. After all, when strong women join together, who can stop them?<br/><br/>Read <i>The Millionth Circle: How to Change Ourselves and the World</i> and find . . .<br/><br/> A tool for creating positive change<br/><br/> Words of insightful and powerful feminine wisdom<br/><br/> A book for women everywhere
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jean Shinoda Bolen
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Conari Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cbb19f4c